import { EuiBadge } from "@inscopix/ideas-eui";

interface TagProps {
  tag: string;
}

export const Tag = ({ tag }: TagProps) => {
  return (
    <EuiBadge iconType="tag" color="hollow">
      {tag}
    </EuiBadge>
  );
};
